import { render, staticRenderFns } from "./TestEdit.vue?vue&type=template&id=037fa7f6"
import script from "./TestEdit.vue?vue&type=script&lang=js"
export * from "./TestEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports